import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ICashRegisterSessionsApiService } from './cash-register-sessions-api.interface';
import { SuccessResponse } from '../../../shared/success-response';
import { REGISTER_ANALYTICS_API_URL } from '../registers-analytics-api.constants';
import { FindRegisterSessionsQueryDto } from './dtos/find-register-sessions.query.dto';
import { FindRegisterSessionsResponseDto } from './dtos/find-register-sessions.response.dto';
import { handleBlobHttpResponse } from '@orderna/admin-panel/src/utils/handle-blob-http-response';
import { ExportRegisterSessionsQueryDto } from './dtos/export-register-sessions.query.dto';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';

@Injectable({
  providedIn: 'root',
})
export class CashRegisterSessionAnalyticsApiService
  implements ICashRegisterSessionsApiService
{
  private readonly API_URL = `${REGISTER_ANALYTICS_API_URL}`;
  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findRegisterSessions(query: FindRegisterSessionsQueryDto) {
    const params = new HttpParams({ fromObject: query as any });
    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindRegisterSessionsResponseDto>>(
        this.API_URL,
        {
          params,
        }
      )
    );

    return response.data;
  }

  async exportRegisterSessions(
    query: ExportRegisterSessionsQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const params = new HttpParams({ fromObject: query as any });
    const response = await firstValueFrom(
      this.http.get(`${this.API_URL}/export`, {
        responseType: 'blob',
        observe: 'response',
        params,
      })
    );

    handleBlobHttpResponse(response, options, this.exportService);
  }
}
